import { HEADER_HEIGHT } from "@/config/data";
import { signOut } from "@/utils/auth";
import { Badge } from "@mantine/core";
import { IconLogout } from "@tabler/icons-react";
import { Link, useLocation } from "react-router-dom";

export const Header = () => {
  const location = useLocation();
  let type;
  let color;
  const path = location.pathname.split("/").pop();
  if (path?.includes("confirmation")) {
    type = "Confirmation";
    color = "blue";
  } else if (path?.includes("qa-jobs")) {
    type = "QA";
    color = "blue";
  } else if (path?.includes("selection")) {
    type = "Labeling";
    color = "yellow";
  }
  return (
    <header
      className="bg-white shadow-sm border-b border-gray-200 fixed top-0 left-0 right-0 z-10"
      style={{ height: HEADER_HEIGHT }}
    >
      <div className="px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <h1 className="text-xl font-semibold text-gray-900">
              <Link to="/">Product Association</Link>
            </h1>
            {type && (
              <Badge color={color} variant="light" size="lg">
                {type}
              </Badge>
            )}
          </div>
          <div className="flex items-center space-x-4">
            <button
              className="text-gray-500 hover:text-gray-700"
              onClick={signOut}
            >
              <IconLogout />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
